import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignUitgeestPage() {
  return <LocalPageTemplate cityName="Uitgeest" region="Kennemerland" introText="Professionele websites voor ondernemers in Uitgeest. Wij bouwen websites die jouw bedrijf op de kaart zetten in dit goed bereikbare knooppunt tussen Alkmaar en de IJmond." localContext="Uitgeest is een compact maar goed bereikbaar dorp op het kruispunt van Kennemerland, de Zaanstreek en de IJmond. Dankzij het treinstation is Uitgeest een populaire woonplaats voor forensen, wat zorgt voor een koopkrachtige bevolking. De lokale economie bestaat uit een mix van winkels, horeca en dienstverleners die profiteren van de strategische ligging. Een goede website helpt ondernemers in Uitgeest om zowel het lokale publiek als klanten uit omliggende gemeenten te bereiken." nearbyLocations={[{
    name: 'Castricum',
    slug: 'castricum'
  }, {
    name: 'Heemskerk',
    slug: 'heemskerk'
  }, {
    name: 'Zaanstad',
    slug: 'zaanstad'
  }, {
    name: 'Alkmaar',
    slug: 'alkmaar'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Uitgeest?',
    a: 'Een professionele bedrijfswebsite in Uitgeest start vanaf €1.500. De investering hangt af van je wensen, van een eenvoudige bedrijfspresentatie tot een uitgebreide site met webshop. We geven altijd vooraf een transparante offerte.'
  }, {
    q: 'Optimaliseren jullie ook voor klanten buiten Uitgeest?',
    a: 'We optimaliseren je website voor zoektermen in Uitgeest én de bredere regio (Castricum, Heemskerk, Zaanstad). Dankzij de centrale ligging van Uitgeest kun je een groot verzorgingsgebied bedienen. Wij zorgen dat je online ook zo gevonden wordt.'
  }, {
    q: 'Bouwen jullie ook WordPress websites in Uitgeest?',
    a: 'Ja, wij zijn gespecialiseerd in WordPress webdesign. Dit biedt jou een flexibele, veilige en makkelijk te beheren website die je zelf kunt bijwerken zonder technische kennis.'
  }]} data-id="element-1857" />;
}